import type { Entity, Property } from '@square/ignition';
import GraphObject from '@square/ignition/dist/types/graph-object';

function compareGraphObject(a: GraphObject, b: GraphObject): number {
  const aName = a.name.startsWith('V1') ? a.name.slice(2) : a.name;
  const bName = b.name.startsWith('V1') ? b.name.slice(2) : b.name;

  if (aName < bName) {
    return -1;
  } else if (aName > bName) {
    return 1;
  } else {
    return 0;
  }
}

/**
 * This is a lazy equal to save some cycles, as the entity lists
 * are generally over 1000 entries, and get populated in the nav.
 * We will just do a lazy check for the length, and ensure the first items match
 * @param a The first list
 * @param b the second list
 * @returns True if the lists are "equal", false otherwise.
 */
function areEntityListsEqual(
  a: Pick<Entity, 'id'>[] | undefined,
  b: Pick<Entity, 'id'>[] | undefined
): boolean {
  return a?.length === b?.length && a?.[0]?.id === b?.[0]?.id;
}

function compareProperties(a: Property, b: Property): number {
  if (a.name === 'id') {
    return -1;
  } else if (b.name === 'id') {
    return 1;
  } else if (a.isDeprecated && !b.isDeprecated) {
    return 1;
  } else if (!a.isDeprecated && b.isDeprecated) {
    return -1;
  } else if (a.required && !b.required) {
    return -1;
  } else if (!a.required && b.required) {
    return 1;
  } else {
    // Let it be sorted as they do in the OAS
    return 0;
  }
}

export { compareGraphObject, areEntityListsEqual, compareProperties };
